/**
 * Slick peek carousel — dot progress bar + focus scroll fix for Slick dots.
 * Used by index-collection-carousel-peek and modular-card-grid (mobile).
 * Loaded by section bundles; safe on any template (single global registration).
 */
(function () {
  if (window.__slickPeekCarouselDotsInit) return;
  window.__slickPeekCarouselDotsInit = true;

  var SECTIONS = [
    {
      rootClass: "index-collection-carousel-peek",
      sliderSelector: ".modular-collection-with-content__slider.slider",
      desktopEndScrollFix: true,
      mobileSwipeSmooth: true,
    },
    {
      rootClass: "modular-card-grid-section",
      sliderSelector: ".mcg__grid.slider",
      mobileSwipeSmooth: true,
    },
  ];

  var PEEK_VISIBLE_RATIO = 4.25;

  function isDesktopPeek() {
    return window.matchMedia("(min-width: 768px)").matches;
  }

  function getPeekSlick(slider) {
    var $ = window.jQuery || window.$;
    if (!$ || !slider.classList.contains("slick-initialized")) return null;
    try {
      return $(slider).slick("getSlick");
    } catch (e) {
      return null;
    }
  }

  function hasPartialLastPage(slick) {
    return slick.slideCount % slick.options.slidesToScroll !== 0;
  }

  function getPageStartIndexes(slick) {
    var scroll = slick.options.slidesToScroll;
    var pageCount = Math.ceil(slick.slideCount / scroll);
    var indexes = [];
    for (var i = 0; i < pageCount; i++) {
      indexes.push(i * scroll);
    }
    return indexes;
  }

  function getLastPageStartIndex(slick) {
    var pages = getPageStartIndexes(slick);
    return pages.length ? pages[pages.length - 1] : -1;
  }

  function getActivePageIndex(slick) {
    return Math.floor(slick.currentSlide / slick.options.slidesToScroll);
  }

  function findPageIndex(slick, slideIndex) {
    var pages = getPageStartIndexes(slick);
    var idx = pages.indexOf(slideIndex);
    if (idx >= 0) return idx;
    for (var i = pages.length - 1; i >= 0; i--) {
      if (slideIndex >= pages[i]) return i;
    }
    return 0;
  }

  function getPeekGap(slick) {
    var firstSlide = slick.$slideTrack.children(".slick-slide").get(0);
    if (!firstSlide) return 0;
    return firstSlide.offsetWidth * (PEEK_VISIBLE_RATIO - Math.floor(PEEK_VISIBLE_RATIO));
  }

  function computePeekEndLeft(slick) {
    var slides = slick.$slideTrack.children(".slick-slide");
    var lastEl = slides.length ? slides[slides.length - 1] : null;
    if (!lastEl) return 0;

    var lastSlideRight = lastEl.offsetLeft + lastEl.offsetWidth;
    var peekGap = getPeekGap(slick);

    return Math.min(0, slick.listWidth - peekGap - lastSlideRight);
  }

  function syncPeekCurrentLeft(slick) {
    if (!isDesktopPeek() || !hasPartialLastPage(slick)) return;
    if (slick.currentSlide === getLastPageStartIndex(slick)) {
      slick.currentLeft = computePeekEndLeft(slick);
    }
  }

  function isLastPageSlide(slick, slideIndex) {
    return hasPartialLastPage(slick) && slideIndex === getLastPageStartIndex(slick);
  }

  function syncPeekDots(slider) {
    var dots = findDotsList(slider);
    var slick = getPeekSlick(slider);
    if (!dots || !slick) return;

    var pageCount = getPageStartIndexes(slick).length;
    dots.querySelectorAll("li").forEach(function (li, i) {
      var isSpare = i >= pageCount;
      var btn = li.querySelector("button");

      if (isSpare) {
        li.classList.add("icc-peek-dot--spare");
        li.classList.remove("slick-active");
        li.setAttribute("aria-hidden", "true");
        if (btn) {
          btn.setAttribute("tabindex", "-1");
          btn.setAttribute("aria-disabled", "true");
        }
      } else {
        li.classList.remove("icc-peek-dot--spare");
        li.removeAttribute("aria-hidden");
        if (btn) {
          btn.removeAttribute("tabindex");
          btn.removeAttribute("aria-disabled");
        }
      }
    });
  }

  function bindMobileSwipeSmoothness(slider) {
    if (slider.getAttribute("data-icc-peek-mobile-smooth") === "true") return;

    var tryBind = function () {
      if (!slider.classList.contains("slick-initialized")) return false;

      var $ = window.jQuery || window.$;
      if (!$) return false;

      var $slider = $(slider);
      slider.setAttribute("data-icc-peek-mobile-smooth", "true");

      var endDrag = function () {
        slider.classList.remove("icc-peek-dragging");
        slider._iccPeekDotDragging = false;
      };

      $slider.on("beforeChange.iccPeekSmooth afterChange.iccPeekSmooth", function () {
        endDrag();
        if (isDesktopPeek()) return;
        window.requestAnimationFrame(function () {
          updateDotPastState(slider, slider._iccPeekDotObs || null);
        });
      });

      $slider.on("touchstart.iccPeekSmooth mousedown.iccPeekSmooth", ".slick-list", function () {
        slider.classList.add("icc-peek-dragging");
        if (!isDesktopPeek()) {
          slider._iccPeekDotDragging = true;
        }
      });

      $slider.on(
        "touchend.iccPeekSmooth touchcancel.iccPeekSmooth mouseup.iccPeekSmooth mouseleave.iccPeekSmooth",
        ".slick-list",
        endDrag
      );

      return true;
    };

    if (!tryBind()) {
      var n = 0;
      var t = setInterval(function () {
        if (!slider.isConnected) {
          clearInterval(t);
          return;
        }
        n += 1;
        if (tryBind() || n > 80) clearInterval(t);
      }, 25);
    }
  }

  function bindPeekDotGuard(dots) {
    if (dots.getAttribute("data-icc-peek-dot-guard") === "true") return;
    dots.setAttribute("data-icc-peek-dot-guard", "true");

    dots._iccPeekSpareClickGuard = function (e) {
      var li = e.target.closest && e.target.closest("li");
      if (!li || !li.classList.contains("icc-peek-dot--spare")) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    };

    dots.addEventListener("click", dots._iccPeekSpareClickGuard, true);
  }

  function patchPeekDesktopEndScroll(slider) {
    if (slider.getAttribute("data-icc-peek-end-scroll") === "true") return;

    var tryPatch = function () {
      var slick = getPeekSlick(slider);
      if (!slick) return false;
      if (slick._iccPeekGetLeftPatched) {
        slider.setAttribute("data-icc-peek-end-scroll", "true");
        return true;
      }

      var $ = window.jQuery || window.$;
      var $slider = $(slider);
      var originalGetLeft = slick.getLeft.bind(slick);
      var originalSwipeStart = slick.swipeStart.bind(slick);

      slick._iccPeekOriginalGetLeft = originalGetLeft;
      slick._iccPeekOriginalSwipeStart = originalSwipeStart;
      slick._iccPeekGetLeftPatched = true;

      slick.getLeft = function (slideIndex) {
        if (isDesktopPeek() && !slick.options.infinite && isLastPageSlide(slick, slideIndex)) {
          return computePeekEndLeft(slick);
        }
        return originalGetLeft(slideIndex);
      };

      slick.swipeStart = function (event) {
        originalSwipeStart(event);
        if (!isDesktopPeek() || !slick.touchObject) return;

        var pageStarts = getPageStartIndexes(slick);
        var currentIdx = findPageIndex(slick, slick.currentSlide);
        var currentLeft = slick.getLeft(slick.currentSlide);
        var travel = slick.listWidth;
        var prevStart = pageStarts[currentIdx - 1];
        var nextStart = pageStarts[currentIdx + 1];

        if (typeof prevStart === "number") {
          travel = Math.min(travel, Math.abs(currentLeft - slick.getLeft(prevStart)));
        }
        if (typeof nextStart === "number") {
          travel = Math.min(travel, Math.abs(currentLeft - slick.getLeft(nextStart)));
        }

        if (travel > 0 && travel < slick.listWidth * 0.5) {
          slick.touchObject.minSwipe = Math.max(36, travel * 0.2);
        }
      };

      $slider.on("setPosition.iccPeekEnd", function (event, activeSlick) {
        syncPeekCurrentLeft(activeSlick || slick);
      });

      slick._iccPeekEndResize = function () {
        var activeSlick = getPeekSlick(slider);
        if (activeSlick && activeSlick.setPosition) activeSlick.setPosition();
      };
      window.addEventListener("resize", slick._iccPeekEndResize);

      slider.setAttribute("data-icc-peek-end-scroll", "true");

      if (hasPartialLastPage(slick) && slick.currentSlide === getLastPageStartIndex(slick)) {
        slick.setPosition();
      }

      return true;
    };

    if (!tryPatch()) {
      var n = 0;
      var t = setInterval(function () {
        if (!slider.isConnected) {
          clearInterval(t);
          return;
        }
        n += 1;
        if (tryPatch() || n > 80) clearInterval(t);
      }, 25);
    }
  }

  function findDotsList(slider) {
    var next = slider.nextElementSibling;
    if (next && next.classList && next.classList.contains("slick-dots")) return next;
    var parent = slider.parentElement;
    if (!parent) return null;
    return parent.querySelector(".slick-dots");
  }

  function updateDotPastState(slider, obs) {
    var dots = findDotsList(slider);
    if (!dots) return;

    syncPeekDots(slider);

    var slick = getPeekSlick(slider);
    var items = dots.querySelectorAll("li");
    var activeIndex = -1;
    items.forEach(function (li, i) {
      if (li.classList.contains("slick-active")) activeIndex = i;
    });

    var pastThrough = activeIndex;
    if (slick) {
      pastThrough = getActivePageIndex(slick);
    }

    if (obs) obs.disconnect();
    try {
      items.forEach(function (li, i) {
        if (li.classList.contains("icc-peek-dot--spare")) {
          li.classList.remove("slick-dot--past");
          return;
        }
        if (pastThrough >= 0 && i <= pastThrough) {
          li.classList.add("slick-dot--past");
        } else {
          li.classList.remove("slick-dot--past");
        }
      });
    } finally {
      if (obs) {
        obs.observe(dots, { subtree: true, attributes: true, attributeFilter: ["class"] });
      }
    }

    var progressCount = 1;
    var activePage = 0;

    if (slick) {
      progressCount = getPageStartIndexes(slick).length;
      activePage = getActivePageIndex(slick);
    } else {
      var allItems = dots.querySelectorAll("li");
      progressCount = allItems.length || 1;
      allItems.forEach(function (li, i) {
        if (li.classList.contains("slick-active")) activePage = i;
      });
    }

    if (activePage >= progressCount) {
      activePage = progressCount - 1;
    }
    if (activePage < 0) {
      activePage = 0;
    }

    var scale = progressCount > 0 ? (activePage + 1) / progressCount : 0;
    dots.style.setProperty("--peek-progress-scale", String(scale));
  }

  function bindDotClickScrollRestore(dots) {
    if (dots.getAttribute("data-icc-peek-scroll-fix") === "true") return;
    dots.setAttribute("data-icc-peek-scroll-fix", "true");

    dots.addEventListener("click", function (e) {
      if (!e.target.closest || !e.target.closest("li")) return;
      if (e.pointerType === "touch") return;

      var before = window.pageYOffset;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var after = window.pageYOffset;
          var delta = Math.abs(after - before);
          if (delta === 0) return;
          var maxUndo = Math.min(320, window.innerHeight * 0.45);
          if (delta <= maxUndo) {
            window.scrollTo(0, before);
          }
        });
      });
    });
  }

  function cleanupSlider(slider) {
    slider.classList.remove("icc-peek-dragging");
    slider._iccPeekDotDragging = false;

    if (slider.getAttribute("data-icc-peek-mobile-smooth") === "true") {
      slider.removeAttribute("data-icc-peek-mobile-smooth");
      var $cleanup = window.jQuery || window.$;
      if ($cleanup) {
        $cleanup(slider).off(".iccPeekSmooth");
      }
    }

    if (slider.getAttribute("data-icc-peek-end-scroll") === "true") {
      slider.removeAttribute("data-icc-peek-end-scroll");
      if (slider._iccPeekEndResize) {
        window.removeEventListener("resize", slider._iccPeekEndResize);
        slider._iccPeekEndResize = null;
      }
      var $ = window.jQuery || window.$;
      if ($) {
        $(slider).off("setPosition.iccPeekEnd");
      }
      var slick = getPeekSlick(slider);
      if (slick && slick._iccPeekGetLeftPatched) {
        if (slick._iccPeekOriginalGetLeft) {
          slick.getLeft = slick._iccPeekOriginalGetLeft;
          slick._iccPeekOriginalGetLeft = null;
        }
        if (slick._iccPeekOriginalSwipeStart) {
          slick.swipeStart = slick._iccPeekOriginalSwipeStart;
          slick._iccPeekOriginalSwipeStart = null;
        }
        slick._iccPeekGetLeftPatched = false;
      }
    }

    if (slider.getAttribute("data-icc-peek-dot-progress") !== "true") return;
    slider.removeAttribute("data-icc-peek-dot-progress");
    if (slider._iccPeekDotObs) {
      slider._iccPeekDotObs.disconnect();
      slider._iccPeekDotObs = null;
    }
    if (slider._iccPeekDotResize) {
      window.removeEventListener("resize", slider._iccPeekDotResize);
      slider._iccPeekDotResize = null;
    }
    var dots = findDotsList(slider);
    if (dots) {
      dots.removeAttribute("data-icc-peek-scroll-fix");
      dots.removeAttribute("data-icc-peek-dot-guard");
      if (dots._iccPeekSpareClickGuard) {
        dots.removeEventListener("click", dots._iccPeekSpareClickGuard, true);
        dots._iccPeekSpareClickGuard = null;
      }
      dots.querySelectorAll("li.icc-peek-dot--spare").forEach(function (li) {
        li.classList.remove("icc-peek-dot--spare");
      });
    }
  }

  function bindDotProgress(slider) {
    if (slider.getAttribute("data-icc-peek-dot-progress") === "true") return;

    var tryBind = function () {
      if (!slider.classList.contains("slick-initialized")) return false;
      var dots = findDotsList(slider);
      if (!dots) return false;

      slider.setAttribute("data-icc-peek-dot-progress", "true");
      bindDotClickScrollRestore(dots);
      bindPeekDotGuard(dots);
      syncPeekDots(slider);

      var obs = null;
      var run = function () {
        if (slider._iccPeekDotDragging) return;
        window.requestAnimationFrame(function () {
          updateDotPastState(slider, obs);
        });
      };
      obs = new MutationObserver(run);
      slider._iccPeekDotObs = obs;
      slider._iccPeekDotResize = run;
      obs.observe(dots, { subtree: true, attributes: true, attributeFilter: ["class"] });

      run();
      setTimeout(run, 50);
      setTimeout(run, 250);
      window.addEventListener("resize", run);
      return true;
    };

    if (!tryBind()) {
      var n = 0;
      var t = setInterval(function () {
        if (!slider.isConnected) {
          clearInterval(t);
          return;
        }
        n += 1;
        if (tryBind() || n > 80) clearInterval(t);
      }, 25);
    }
  }

  function bindSlidersIn(root, sliderSelector, options) {
    options = options || {};
    var sliders;
    if (root && root !== document && root.querySelectorAll) {
      sliders = root.querySelectorAll(sliderSelector);
    } else {
      sliders = document.querySelectorAll(sliderSelector);
    }
    sliders.forEach(function (el) {
      if (options.desktopEndScrollFix) {
        patchPeekDesktopEndScroll(el);
      }
      if (options.mobileSwipeSmooth) {
        bindMobileSwipeSmoothness(el);
      }
      bindDotProgress(el);
    });
  }

  function bindAllSections(root) {
    SECTIONS.forEach(function (config) {
      var scope = root;
      if (root && root !== document && root.classList && !root.classList.contains(config.rootClass)) {
        return;
      }
      if (root && root !== document && root.classList && root.classList.contains(config.rootClass)) {
        bindSlidersIn(root, config.sliderSelector, config);
      } else if (!root || root === document) {
        document.querySelectorAll("." + config.rootClass).forEach(function (section) {
          bindSlidersIn(section, config.sliderSelector, config);
        });
      }
    });
  }

  function onReady() {
    bindAllSections(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target || !e.target.classList) return;
    SECTIONS.forEach(function (config) {
      if (e.target.classList.contains(config.rootClass)) {
        bindSlidersIn(e.target, config.sliderSelector, config);
      }
    });
  });

  document.addEventListener("shopify:section:unload", function (e) {
    if (!e.target || !e.target.classList) return;
    SECTIONS.forEach(function (config) {
      if (e.target.classList.contains(config.rootClass)) {
        e.target.querySelectorAll(config.sliderSelector).forEach(cleanupSlider);
      }
    });
  });
})();
